if (!customElements.get('video-player')) {
  class VideoPlayer extends HTMLElement {
    connectedCallback() {
      this._init();

      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;

        const { action } = clickedElement.dataset;

        switch (action) {
          case 'play':
            this.video.muted = false;
            this.video.play();
            this.setAttribute('data-state', 'playing');
            break;
          case 'pause':
            this.video.pause();
            this.setAttribute('data-state', 'paused');
            break;
        }
      });
    }

    _init() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      this.video.querySelector('img')?.setAttribute('alt', 'video player poster image.');

      const progressBarInner = this.querySelector('[data-progress-bar-inner]');
      const circularProgressBar = this.querySelector('[data-circular-progress-bar]');
      const radius = circularProgressBar?.r.baseVal.value;
      const circumference = radius ? 2 * Math.PI * radius : 0;

      if (circularProgressBar) {
        circularProgressBar.style.strokeDasharray = `${circumference}`;
        circularProgressBar.style.strokeDashoffset = `${circumference}`;
      }

      this.video.addEventListener('timeupdate', () => {
        const curr = (this.video.currentTime / this.video.duration) * 100;
        if (progressBarInner) progressBarInner.style.width = `${curr}%`;
        if (circularProgressBar) {
          circularProgressBar.style.strokeDashoffset = `${circumference - (curr / 100) * circumference}`;
        }
      });

      this.video.addEventListener('ended', () => {
        this.setAttribute('data-state', 'ended');
        this.video.pause();
        this.video.load();
        if (progressBarInner) progressBarInner.style.width = null;
        if (circularProgressBar) circularProgressBar.style.strokeDashoffset = `${circumference}`;
      });

      if (this.dataset.autoplay === 'true') {
        this._autoplay();
      }
    }

    _autoplay() {
      this.video.muted = true;
      this.video.playsInline = true;

      const attempt = () => {
        this.video.play().then(() => {
          this.setAttribute('data-state', 'playing');
        }).catch(() => {
          this.video.addEventListener('canplay', () => {
            this.video.play().then(() => {
              this.setAttribute('data-state', 'playing');
            }).catch(() => {
              this.setAttribute('data-state', 'paused');
            });
          }, { once: true });
        });
      };

      if (this.video.readyState < 1) {
        this.video.addEventListener('loadedmetadata', attempt, { once: true });
      } else {
        attempt();
      }
    }
  }

  customElements.define('video-player', VideoPlayer);
}
